import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getRightExerciseTypeList as getRightExerciseTypeListApi,
	getRightExerciseTypeListQuery as getRightExerciseTypeListQueryApi,
	getRightExerciseType as getRightExerciseTypeApi,
	addNewRightExerciseTypeApi,
	updateRightExerciseTypeApi,
	deleteRightExerciseTypeApi,
	checkRightExerciseTypeExistsApi,
} from '../../helpers/right_exercise_type/api_helper';

export const getRightExerciseTypeList = createAsyncThunk(
	'rightExerciseType/getRightExerciseTypeList',
	async () => {
		try {
			const response = await getRightExerciseTypeListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener los ejercicios de derecho.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getRightExerciseTypeListQuery = createAsyncThunk(
	'rightExerciseType/getRightExerciseTypeListQuery',
	async params => {
		try {
			const response = getRightExerciseTypeListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getRightExerciseType = createAsyncThunk(
	'rightExerciseType/getRightExerciseType',
	async right_exercise_type_id => {
		try {
			const response = await getRightExerciseTypeApi(right_exercise_type_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el ejercicio de derecho.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewRightExerciseType = createAsyncThunk(
	'rightExerciseType/addNewRightExerciseType',
	async right_exercise_type => {
		try {
			const response = await addNewRightExerciseTypeApi(right_exercise_type);
			toast.success('Ejercicio de Derecho agregado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el ejercicio de derecho.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateRightExerciseType = createAsyncThunk(
	'rightExerciseType/updateRightExerciseType',
	async right_exercise_type => {
		try {
			const response = await updateRightExerciseTypeApi(right_exercise_type);
			toast.success('Ejercicio de Derecho actualizado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el ejercicio de derecho.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteRightExerciseType = createAsyncThunk(
	'rightExerciseType/deleteRightExerciseType',
	async right_exercise_type => {
		try {
			const response = await deleteRightExerciseTypeApi(right_exercise_type._id);
			toast.success('Ejercicio de Derecho eliminado exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return right_exercise_type;
		} catch (error) {
			toast.error('Error al eliminar el ejercicio de derecho.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkRightExerciseTypeExists = createAsyncThunk(
	'rightExerciseType/checkRightExerciseTypeExists',
	async name => {
		try {
			const response = await checkRightExerciseTypeExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
